angular.module("componentes").controller("menuLinkCtrl", [
	"$scope",
	function ($scope) {
		"use strict";
		this.$onInit = function () {
			$scope.showDisabled = $scope.ctrl.item.featureAccess == Vgr.enumerations.userAccess.Disabled;
		};
	}
]);
